import { Container, Label, FormGroup, Input } from "reactstrap";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
// import TextErrors from '../../share/TextErrors'
import "../../share/form.css";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import Swal from 'sweetalert2'
import { bahttext } from "bahttext"


export function OperationReportForm32Component() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const supportId = searchParams.get("req")
    // console.log(supportId)
    const [data, setData] = useState([]);

    console.log("data", data)
    useEffect(() => {
        const getData = async () => {
            try {
                let res = await fetch(`api/Support/getSupportOperationData/${supportId}`)
                const resJson = await res.json()
                setData(resJson.dataenum);
            } catch (err) {
                console.log("err", err)
            }
        }
        getData();
    }, [supportId])


    const initialValues = {
        supportId: supportId,
        supportRemark: "",
        benefitRemark: "",
        supportCheckbox: [],
        benefitCheckbox: [],
        issue: "",
        remark: "",
    };

    const onSubmit = async (values) => {
        if (values.supportCheckbox.length === 0 || values.benefitCheckbox.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "กรุณาเลือกอย่างน้อย 1 ข้อ",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
            return;
        } else {
            try {
                let res = await fetch("/api/Support/saveSupportOperation", {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify(values)
                });

                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        navigate("/supporting")
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                console.log(e)
            }
        }

    }

    const validationSchema = Yup.object().shape({
        // casecheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        // benefitCheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        supportRemark: Yup.string()
    })


    return (
        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <div className="form-border">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {
                        // console.log("values", values)
                        return (
                            <Form className="p-5 mb-4">
                                {data?.map((item, i) => (
                                    <div className="mt-3">
                                        <Label>ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportName}</p>
                                        <div className="mt-3 d-flex justify-content-betwenn align-items-center w-100">
                                            <div className="w-50 p-1">
                                                <Label className="form-Label">เลขที่คำขอ</Label>
                                                {item.supportNo !== null ? (
                                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportNo}</p>
                                                ) : (
                                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">-</p>
                                                )}
                                            </div>
                                            <div className="w-50 p-1">
                                                <Label className="form-Label">ลงวันที่</Label>
                                                <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.approveDate}</p>
                                            </div>
                                        </div>

                                        <Label className="form-Label">ได้รับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (หน่วยงานที่อนุมัติคำขอ)</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.deptName}</p>

                                        <Label className="form-Label">เป็นจำนวนเงิน</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{NumberWithCommas(item.amount)} บาท ({bahttext(item.amount)})</p>
                                    </div>
                                ))}

                                {/* checkbox 2 */}
                                <FormGroup className="mt-5">

                                    <p className="input-color">นำเงินช่วยเหลือหรืออุดหนุนที่ได้รับจากกองทุนพัฒนาฝีมือแรงงานไปส่งเสริมการพัฒนาฝีมือแรงงาน ดังนี้</p>
                                    <div className="form-check">
                                        <Field type="checkbox" name="supportCheckbox" value="01" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการปรับปรุงอาคาร สถานที่ สำหรับใช้ในการประเมินความรู้ความสามารถ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="02" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการจัดหาวัสดุ อุปกรณ์สำนักงานสำหรับใช้ในการประเมินความรู้ความสามารถ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="03" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการบริหารจัดการในกระบวนการประเมินความรู้ความสามารถ เช่น ค่าตอบแทนผู้ประเมิน ค่าสาธารณูปโภค เป็นต้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="04" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการพัฒนาผู้ประเมินความรู้ความสามารถ
                                        </Label>
                                    </div>

                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="05" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label ">
                                            อื่นๆ (โปรดระบุ)
                                        </Label>
                                        <Field
                                            name="supportRemark"
                                            className="rounded-pill"
                                        >
                                            {({ field, form, meta }) => (
                                                <Input
                                                    type="text"
                                                    className="rounded-pill"
                                                    {...field}
                                                />

                                            )}
                                        </Field>
                                    </div>
                                </FormGroup>

                                {/* checkbox 3 */}
                                <FormGroup className="mt-4">
                                    <p className="input-color">ประโยชน์ที่ได้รับจากการดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง</p>
                                    <div className="form-check">
                                        <Field type="checkbox" name="benefitCheckbox" value="01" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถดำเนินการประเมินความรู้ความสามารถได้เพิ่มมากขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="02" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถเพิ่มสาขาอาชีพที่จะดำเนินการประเมินความรู้ความสามารถได้เพิ่มมากขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="03" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label " >
                                            สามารถปรับปรุง จัดหาวัสดุ อุปกรณ์ เพื่อใช้ในการประเมินความรู้ความสามารถ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="04" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถปรับปรุง ซ่อมแซมอาคารสถานที่ให้มีสภาพเหมาะสม
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="05" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถพัฒนาผู้ประเมินความรู้ความสามารถได้เพิ่มมากขึ้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="06" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถประเมินความรู้ความสามารถให้กับผู้ที่จะไปทำงานในสาขาอาชีพที่จะเป็นอันตรายต่อสาธารณะเพิ่มมากขึ้น
                                        </Label>
                                    </div>

                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="07" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            อื่นๆ (โปรดระบุ)
                                        </Label>
                                        <Field
                                            name="benefitRemark"
                                            className="rounded-pill"
                                        >
                                            {({ field, form, meta }) => (
                                                <Input
                                                    type="text"
                                                    // disabled={values.benefitCheckbox.includes(element => element === "14")} 
                                                    className="rounded-pill"
                                                    {...field}
                                                />

                                            )}
                                        </Field>
                                    </div>
                                </FormGroup>

                                {/* issue */}
                                <FormGroup className="mt-3">
                                    <Label>ปัญหาอุปสรรค</Label>
                                    <Field
                                        name="issue"
                                    >
                                        {({ field, form }) => (
                                            <Input
                                                type="text"
                                                className="rounded-pill"
                                                {...field}
                                            />
                                        )}

                                    </Field>

                                </FormGroup>

                                {/* remark  */}
                                <FormGroup className="mt-3">
                                    <Label>ข้อคิดเห็นและเสนอแนะ</Label>
                                    <Field
                                        name="remark"
                                    >
                                        {({ field, form }) => (
                                            <Input
                                                type="text"
                                                className="rounded-pill"
                                                {...field}
                                            />
                                        )}

                                    </Field>
                                </FormGroup>

                                <div className="mt-3 d-flex justify-content-center">
                                    {/* <button className="bg-primary text-white w-25 p-2 rounded-pill border-0">ย้อนกลับ</button> */}
                                    <button className="bg-primary text-white w-25 p-2 rounded-pill border-0" type="submit">บันทึก</button>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>

            </div>

        </Container>

    )
}